"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSelectedStructuredProductMenu = exports.renderStructuredProductMenus = exports.GetStructuredProductNavDropDown = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var react_2 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var StyledComponents_1 = require("./StyledComponents");

var ProductMenu_1 = require("../ProductMenu/ProductMenu");

var styled_1 = __importDefault(require("@emotion/styled"));

var ProductContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\topacity: 0;\n\ttransition: opacity 0.3s;\n\t-o-transition: all 0.3s;\n\t-ms-transition: all 0.3s;\n\t-moz-transition: all 0.3s;\n\t-webkit-transition: all 0.3s;\n\n\t&.animExpand {\n\t\topacity: 1;\n\t}\n"])));

var GetStructuredProductNavDropDown = function GetStructuredProductNavDropDown(product, productId, isExpanded, mobileBreakPoint, theme, setSelectedProductMenuId, setOpenUtilMenu, bodyBindClick, bodyUnbindClick, bodyClicked) {
  var _theme$colors$primary = theme.colors.primary,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      lightGray = _theme$colors$primary.lightGray,
      primaryBrand = _theme$colors$primary.primaryBrand;
  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
    className: "product-menu-root",
    dataTestId: "product-menu-root-".concat(product),
    onClick: function onClick(e) {
      e.stopPropagation();
      setSelectedProductMenuId(function (prevState) {
        if (prevState === productId) {
          document && bodyUnbindClick(bodyClicked);
          return "";
        } else {
          setOpenUtilMenu("");
          document && bodyBindClick(bodyClicked);
          return productId;
        }
      });
    },
    css: (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t", "\n\t\t\t"])), isExpanded && (0, StyledComponents_1.UtilityItemHilite)(primaryBrand)),
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        breakPoint: mobileBreakPoint,
        size: "md",
        weight: "bold",
        color: secondaryBrand,
        className: "utility-item-name",
        children: product
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      css: (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\t\tpadding-top: 3px;\n\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t"]))),
      children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
        className: "icon",
        css: (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t@media only screen and (max-width: ", "px) {\n\t\t\t\t\t\t\tpadding: 1px;\n\t\t\t\t\t\t}\n\t\t\t\t\t"])), mobileBreakPoint),
        icon: "chevron-down",
        size: "xs",
        color: lightGray,
        "data-dataTestId": "product-menu-root-icon"
      })
    })]
  });
};

exports.GetStructuredProductNavDropDown = GetStructuredProductNavDropDown;

var renderStructuredProductMenus = function renderStructuredProductMenus(headerData, productNavigationInner, mobileBreakPoint, theme, setSelectedProductMenuId, setOpenUtilMenu, selectedProductMenuId, bodyBindClick, bodyUnbindClick, bodyClicked, isSticky) {
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    style: productNavigationInner,
    css: isSticky && {
      margin: "0px 20px 0px 20px"
    },
    children: headerData && headerData.map(function (productMenu, index) {
      return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        "data-testid": "product-menu-".concat(productMenu.label),
        children: (0, exports.GetStructuredProductNavDropDown)(productMenu.label, productMenu.contentful_id, productMenu.contentful_id === selectedProductMenuId, mobileBreakPoint, theme, setSelectedProductMenuId, setOpenUtilMenu, bodyBindClick, bodyUnbindClick, bodyClicked)
      }, "products-".concat(index));
    })
  });
};

exports.renderStructuredProductMenus = renderStructuredProductMenus;

var renderSelectedStructuredProductMenu = function renderSelectedStructuredProductMenu(product, selectedMenuId, isSticky, storeDirectory) {
  return (product === null || product === void 0 ? void 0 : product.contentful_id) && (0, jsx_runtime_1.jsx)(Transition, {
    children: (0, jsx_runtime_1.jsx)(ProductMenu_1.StructuredProductMenu, {
      isExpanded: selectedMenuId === product.contentful_id,
      product: product,
      isSticky: isSticky,
      storeDirectory: storeDirectory
    })
  });
};

exports.renderSelectedStructuredProductMenu = renderSelectedStructuredProductMenu;

var Transition = function Transition(_a) {
  var children = _a.children,
      _a$duration = _a.duration,
      duration = _a$duration === void 0 ? "0.3" : _a$duration,
      childProps = __rest(_a, ["children", "duration"]);

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      hasMounted = _react_1$default$useS2[0],
      setHasMounted = _react_1$default$useS2[1];

  var node = (0, react_1.createRef)();
  (0, react_1.useEffect)(function () {
    setHasMounted(true);
  }, []);
  (0, react_1.useEffect)(function () {
    setTimeout(function () {
      var _a, _b;

      (_b = (_a = node.current) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add("animExpand");
    }, 100);
    return function () {
      var _a, _b;

      (_b = (_a = node.current) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove("animExpand");
    };
  }, [hasMounted]);
  return (0, jsx_runtime_1.jsx)(ProductContainer, {
    ref: node,
    children: children
  });
};